export const TerminalIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="-mt-[1px]"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.72444 2.90196C2.92589 2.7131 3.24231 2.7233 3.43118 2.92476L6.93118 6.65809C7.11149 6.85042 7.11149 7.1497 6.93118 7.34203L3.43118 11.0754C3.24231 11.2768 2.92589 11.287 2.72444 11.0982C2.52298 10.9093 2.51277 10.5929 2.70164 10.3914L5.88104 7.00006L2.70164 3.6087C2.51277 3.40724 2.52298 3.09083 2.72444 2.90196Z"
        fill="currentColor"
      />
      <rect x="7" y="11" width="5" height="1" rx="0.5" fill="currentColor" />
    </svg>
  )
}
